<template>
  <div class="myOrder">
    <div class="myOrder-content">
      <div class="search-box">
        <div class="search-date">
          下单日期：
          <a-date-picker
            :disabledDate="disabledStartDate"
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            v-model="startValue"
            placeholder="选择时间"
            @openChange="handleStartOpenChange"
          /> -
          <a-date-picker
            :disabledDate="disabledEndDate"
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            placeholder="选择时间"
            v-model="endValue"
            :open="endOpen"
            @openChange="handleEndOpenChange"
          />
        </div>
        <div class="search-key">
          <a-input-group compact>
            <a-select class="orderSelect" defaultValue="xcx_order_id" @change="changeSearchKey">
              <a-select-option
                v-for="(item ,index) in  selectList"
                :key="index"
                :value="item.value"
              >{{item.name}}</a-select-option>
            </a-select>
            <a-input class="oredrInput" style="width: 50%" v-model="selectValue"/>
          </a-input-group>
        </div>
        <div class="search-status">
          订单状态:
          <a-dropdown>
            <a-menu slot="overlay" @click="searchStatus">
              <a-menu-item v-for="(item,index) in orderStatus" :key="index">{{item.name}}</a-menu-item>
            </a-menu>
            <a-button class="orderBtn" style="margin-left: 8px">
              {{currentStatus.name}}
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>
        </div>
        <a-button type="primary" class="search-btn" @click="submitSearch">搜索</a-button>
      </div>
      <a-table
        class="myOrder-table"
        :columns="columns"
        :dataSource="data"
        rowKey="id"
        @change="pageChange"
        :pagination="pagination"
        :loading="tableLoading"
      >
        <span slot="customer_manager" slot-scope="record" href="javascript:;">
          <div>{{record.customer_manager}}</div>
          <div>{{record.customer_manager_mobile}}</div>
        </span>
        <span slot="support_manager" slot-scope="record" href="javascript:;">
          <div>{{record.support_manager}}</div>
          <div>{{record.support_manager_mobile}}</div>
        </span>
        <span
          slot="is_first_order"
          slot-scope="record"
          href="javascript:;"
        >{{record.is_first_order == 1 ? '是' : '否' }}</span>
        <span
          slot="ordercode"
          slot-scope="record"
          href="javascript:;"
        >{{record.order_code == 0 ? '/' : record.order_code }}</span>
        <span slot="material" slot-scope="material" href="javascript:;">
          <span v-if="material.type == 1 && material.status == 0">资料录入</span>
          <span v-else>已录入</span>
        </span>
        <!-- slot-scope 在vue中推荐使用  v-slot 但是在此不能使用 -->
        <span class="operaGroup" slot="operation" slot-scope="record" href="javascript:;">
          <a href="javascript:;" @click="redReport(record)">查看喜报</a>
          <a
            v-if="record.type == 1 && record.status == 0"
            href="javascript:;"
            @click="materialEnter(record.id)"
          >资料录入</a>
          <a
            v-else-if="!( record.type == 6 && record.status == 1)"
            href="javascript:;"
            @click="materialComplete(record.id,record.client_data_type)"
          >完善产品资料</a>
          <a
            v-if="!(record.type == 1 && record.status == 0)"
            href="javascript:;"
            @click="showDrawer(record)"
          >查看订单</a>
        </span>
      </a-table>
    </div>
    <a-modal title="喜报" v-model="redReportVisible" @ok="handleOk" okText="下载" width="423px">
      <div class="redReportBox">
        <img src="../../assets/redReport.png" alt="redReport">
        <div class="redReport-info">
          <a-row class="redReport-row" :gutter="16" v-for="(item,index) in reportData" :key="index">
            <a-col class="redReport-title" :span="8">{{item.key}}</a-col>
            <a-col class="redReport-value" :span="16">{{item.value}}</a-col>
          </a-row>
          <a-row class="redReport-row" :gutter="16">
            <a-col :span="8"></a-col>
            <a-col class="redReport-pass" :span="16">已通过审核</a-col>
          </a-row>
        </div>
      </div>
    </a-modal>
    <a-drawer
      title="订单详情"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="visible"
      width="637px"
      getContainer=".myOrder"
    >
      <div class="section order-info">
        <a-row :gutter="16">
          <a-col
            :title="orderDetail.client_name"
            class="order-info-value"
            :span="8"
          >客户名称：{{orderDetail.client_name}}</a-col>
          <a-col
            :title="orderDetail.buy_product"
            class="order-info-value"
            :span="8"
          >产品名称：{{orderDetail.buy_product}}</a-col>
          <a-col
            :title="orderDetail.xcx_order_id"
            class="order-info-value"
            :span="8"
          >订单编号：{{orderDetail.xcx_order_id}}</a-col>
        </a-row>
        <a-row>
          <a-col :span="24">排单码： {{orderDetail.order_code == 0 ? '' : orderDetail.order_code}}</a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            排单二维码：
            <img
              v-if="stackQrcode"
              :src="stackQrcode"
              alt="stackQrcode"
              style="display:inline-block;width:110px;height:110px;vertical-align: top;border:1px solid rgba(232,234,245,1);"
            >
          </a-col>
        </a-row>
      </div>
      <div class="section order-step">
        <a-steps direction="vertical" :current="orderDetail.type-1" progressDot>
          <a-step v-for="(item,index) in orderDetail.order_log" :key="index">
            <div v-if="item.type == 1" slot="title" class="detail-header">
              <div class="title">资料审核</div>
              <div v-if="item.status == 1" class="status orange">审核中</div>
              <div v-else-if="item.status == 2" class="status blue">审核通过</div>
              <div v-else-if="item.status == 3" class="status red">审核不通过</div>
            </div>
            <div v-else-if="item.type == 2" slot="title" class="detail-header">
              <div class="title">运营对接</div>
              <div v-if="item.status == 0" class="status orange">未完成</div>
              <div v-else-if="item.status == 1" class="status gray">已完成</div>
            </div>
            <div v-else-if="item.type == 3" slot="title" class="detail-header">
              <div class="title">组建对接群</div>
              <div v-if="item.status == 0" class="status orange">未完成</div>
              <div v-else-if="item.status == 1" class="status gray">已完成</div>
            </div>
            <div v-else-if="item.type == 4" slot="title" class="detail-header">
              <div class="title">小程序注册</div>
              <div v-if="item.status == 0" class="status orange">未完成</div>
              <div v-else-if="item.status == 1" class="status gray">已完成</div>
            </div>
            <div v-else-if="item.type == 5" slot="title" class="detail-header">
              <div class="title">小程序制作</div>
              <div v-if="item.status == 0" class="status orange">未开始</div>
              <div v-else-if="item.status == 1" class="status blue">制作中</div>
              <div v-else-if="item.status == 2" class="status gray">已完成</div>
              <div v-else-if="item.status == 3" class="status red">延期中</div>
            </div>
            <div v-else-if="item.type == 6" slot="title" class="detail-header">
              <div class="title">小程序发布上线</div>
              <div v-if="item.status == 0" class="status orange">未完成</div>
              <div v-else-if="item.status == 1" class="status gray">已完成</div>
            </div>

            <div slot="description">
              <div class="update-time">更新时间：{{item.operate_time}}</div>
              <div v-if="item.type == 1">
                <div
                  v-if="item.status == 3"
                  class="step-info audit_note"
                >审核不通过原因：{{item.form_data.audit_note?item.form_data.audit_note:''}}</div>
              </div>
              <div v-else-if="item.type == 2">
                <div class="step-info">运营专员电话：{{item.form_data.operation_phone}}</div>
                <div class="step-info">
                  运营专员微信：
                  <img
                    v-if="item.form_data.operation_wechat"
                    :src="item.form_data.operation_wechat"
                  >
                </div>
              </div>
              <div v-else-if="item.type == 3">
                <div class="step-info">
                  对接群：
                  <img v-if="item.form_data.work_qrcode" :src="item.form_data.work_qrcode">
                </div>
              </div>
              <div v-else-if="item.type == 4"></div>
              <div v-else-if="item.type == 5">
                <div
                  class="step-info"
                >排期时间：{{item.form_data.start_date? item.form_data.start_date + '~' +item.form_data.end_date:''}}</div>
              </div>
              <div v-else-if="item.type == 6">
                <div v-if="item.status == 1" class="step-info">
                  小程序二维码：
                  <img
                    v-if="item.form_data.xcx_qrcode"
                    :src="item.form_data.xcx_qrcode"
                    alt="xcx_qrcode"
                  >
                </div>
                <div class="step-info">
                  后台地址：
                  <a href="https://www.jisuapp.cn" target="_blank">www.jisuapp.cn</a>
                </div>
                <div class="step-info">
                  使用教程：
                  <a
                    href="https://school.jisuapp.cn/courses/143.html"
                    target="_blank"
                  >school.jisuapp.cn/courses/143.html</a>
                </div>
              </div>
            </div>
          </a-step>
        </a-steps>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
const td_width = 120;
const columns = [
  {
    title: "订单号",
    width: td_width,
    dataIndex: "xcx_order_id",
    key: "xcx_order_id"
  },
  {
    title: "客户",
    width: td_width,
    dataIndex: "client_name",
    key: "client_name"
  },
  {
    title: "公司",
    width: td_width,
    dataIndex: "client_company_name",
    key: "client_company_name"
  },
  {
    title: "产品名称",
    dataIndex: "buy_product",
    key: "buy_product",
    width: td_width
  },
  {
    title: "客户经理",
    key: "customer_manager",
    width: td_width,
    scopedSlots: { customRender: "customer_manager" }
  },
  {
    title: "支撑经理",
    key: "support_manager",
    width: td_width,
    scopedSlots: { customRender: "support_manager" }
  },
  {
    title: "是否首单",
    key: "is_first_order",
    width: 100,
    scopedSlots: { customRender: "is_first_order" }
  },
  { title: "订单状态", dataIndex: "text", key: "text", width: td_width },
  {
    title: "资料状态",
    key: "material",
    width: td_width,
    scopedSlots: { customRender: "material" }
  },
  {
    title: "创建时间",
    dataIndex: "buy_time",
    key: "buy_time",
    width: td_width
  },
  {
    title: "排单号",
    key: "order_code",
    scopedSlots: { customRender: "ordercode" }
  },
  {
    title: "操作",
    key: "operation",
    width: td_width,
    scopedSlots: { customRender: "operation" }
  }
];
const selectList = [
  {
    value: "xcx_order_id",
    name: "订单号"
  },
  {
    value: "order_code",
    name: "排单码"
  },
  {
    value: "client_name",
    name: "客户名称"
  }
];

const orderStatus = [
  { value: 0, name: "请选择订单状态" },
  { value: 1, name: "客户资料收集中" },
  { value: 2, name: "客户资料审核中" },
  { value: 3, name: "客户资料审核通过" },
  { value: 4, name: "客户资料审核不通过" },
  // { value: 5, name: "运营对接未完成" },
  { value: 6, name: "运营对接完成" },
  // { value: 7, name: "组建对接未完成" },
  { value: 8, name: "组建对接完成" },
  // { value: 9, name: "小程序注册未完成" },
  { value: 10, name: "小程序注册完成" },
  // { value: 11, name: "小程序制作未开始" },
  { value: 12, name: "小程序制作中" },
  { value: 13, name: "小程序已制作完成" },
  { value: 14, name: "小程序延期中" },
  // { value: 15, name: "发布上线未完成" },
  { value: 16, name: "发布上线完成" }
];
export default {
  data() {
    return {
      data: [],
      columns,
      orderStatus,
      selectList,
      startValue: null,
      endValue: null,
      endOpen: false,
      visible: false,
      redReportVisible: false,
      stackQrcode: "",
      orderDetail: [],
      currentStatus: {
        value: 0,
        name: "请选择订单状态"
      },
      selectValue: "",
      searchKey: "xcx_order_id",
      reportData: {},
      pagination: {
        pageSize: 6,
        total: 1,
        current: 1
      },
      tableLoading: false
    };
  },
  created() {
    this.getOrderList();
  },
  computed: {},
  methods: {
    //获取列表信息
    getOrderList(params = {}) {
      this.tableLoading = true;
      let data = {
        page: 1,
        page_size: 6
      };
      Object.assign(data, params);
      axios({
        url: "/api/workOrder/orderList",
        method: "POST",
        data: data
      }).then(res => {
        let data = res.data;
        this.data = data.data;
        this.pagination.total = data.total_page * 6;
        this.pagination.current = data.current_page;
        this.tableLoading = false;
      });
    },
    //选择日期
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    //搜索关键词
    changeSearchKey(value) {
      this.searchKey = value;
    },
    //订单状态
    searchStatus(e) {
      console.log(e)
      this.currentStatus = this.orderStatus[e.key];
    },
    //提交搜索条件
    submitSearch() {
      let data = this.getSearchParams();
      this.getOrderList(data);
    },
    getSearchParams() {
      let data = {};
      if (this.startValue && this.endValue) {
        data.buy_time_start = this.startValue.format("YYYY-MM-DD hh:mm:ss");
        data.buy_time_end = this.endValue.format("YYYY-MM-DD hh:mm:ss");
      }
      if (this.selectValue) {
        data[this.searchKey] = this.selectValue;
      }
      data.status = this.currentStatus.value;
      return data;
    },
    //翻页
    pageChange(page) {
      let data = Object.assign({ page: page.current }, this.getSearchParams());
      this.getOrderList(data);
    },
    //查看详情
    showDrawer(record) {
      this.visible = true;
      document.querySelector("#app").classList.add("bodyLock");
      this.getOrderLog(record.id);
      this.getStackQrcode(record.order_code);
    },
    //获取排单码二维码
    getStackQrcode(code) {
      if (!code || code == 0) return;
      let scene = encodeURIComponent(code);
      axios({
        url: "/api/WorkOrder/GenerateQRCode",
        method: "POST",
        data: {
          qrcode_type: 0,
          path: `workOrder/pages/orderDetail/orderDetail`,
          scene: scene
        }
      }).then(res => {
        this.stackQrcode = res.data.data;
      });
    },
    //获取详情
    getOrderLog(id) {
      axios({
        url: "/api/workOrder/OrderLog",
        method: "POST",
        data: {
          order_id: id
        }
      }).then(res => {
        let data = res.data.data;
        let log = data.order_log || [];
        log.map((v, k) => {
          if (v.form_data) {
            log[k].form_data = JSON.parse(log[k].form_data);
          }
        });
        this.orderDetail = data;
      });
    },
    //关闭详情
    onClose() {
      this.visible = false;
      document.querySelector("#app").classList.remove("bodyLock");
    },
    //资料录入
    materialEnter(id) {
      let url = "/api/WorkOrder/OrderDetailCache";
      axios({
        url: url,
        method: "POST",
        data: {
          order_id: id
        }
      }).then(res => {
        let data = res.data.data;
        let client_data_type = data.client_data_type || 1;
        this.$router.push(`/enterOrder/${id}/${client_data_type}`);
      });
    },
    //完善产品资料
    materialComplete(id, client_data_type) {
      this.$router.push(`/enterOrder/${id}/${client_data_type}/1`);
    },
    //查看喜报
    redReport(e) {
      let reportData = [
        { key: "恭喜", value: e.manager_area + e.department },
        { key: "客户公司", value: e.client_company_name || "" },
        { key: "客户经理", value: e.customer_manager },
        { key: "支撑经理", value: e.support_manager },
        { key: "成功扩展", value: e.buy_product },
        { key: "总金额", value: e.total_price },
        { key: "小程序金额", value: e.xcx_price },
        { key: "云资源金额", value: e.cloud_price },
        { key: "您的订单", value: e.xcx_order_id }
      ];
      if (!e.client_company_name) {
        reportData.splice(1, 1);
      }
      this.reportData = reportData;
      this.redReportVisible = true;
    },
    handleOk(e) {
      let width = 375; //获取dom 宽度
      let height = 667; //获取dom 高度
      let canvas = document.createElement("canvas"); //创建一个canvas节点
      let scale = 2; //定义任意放大倍数 支持小数
      canvas.width = width * scale; //定义canvas 宽度 * 缩放
      canvas.height = height * scale; //定义canvas高度 *缩放
      canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
      let opts = {
        scale: scale, // 添加的scale 参数
        canvas: canvas, //自定义 canvas
        logging: false, //日志开关，便于查看html2canvas的内部执行流程
        width: width, //dom 原始宽度
        height: height
      };
      html2canvas(document.querySelector(".redReportBox"), opts).then(file => {
        // let context = file.getContext("2d");
        // // 【重要】关闭抗锯齿
        // context.mozImageSmoothingEnabled = false;
        // context.webkitImageSmoothingEnabled = false;
        // context.msImageSmoothingEnabled = false;
        // context.imageSmoothingEnabled = false;
        let imgUri = file
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream"); // 获取生成的图片的url
        let saveLink = document.createElement("a");
        saveLink.href = imgUri;
        saveLink.download = "喜报.png";
        saveLink.click();
        this.redReportVisible = false;
      });
    }
  }
};
</script>
<style scoped>
.myOrder {
  padding: 20px 0;
  min-height: calc(100vh - 66px);
  font-size: 12px;
}
.myOrder-content {
  background: #fff;
  border-radius: 10px;
  padding: 0 20px;
  width: 1461px;
  margin: 0 auto;
}
.search-box {
  display: flex;
  height: 72px;
  align-items: center;
  border-bottom: 1px dashed #e8eaf5;
}
.search-btn {
  width: 72px;
  height: 31px;
  border-radius: 15px;
}
.search-date,
.search-status {
  margin-right: 20px;
}
.search-date >>> .ant-input {
  border-radius: 16px;
}
.search-key >>> .ant-select-selection {
  border-radius: 16px 0 0 16px !important;
  width: 120px;
  color: #303445;
}
.search-key .oredrInput {
  border-radius: 0 16px 16px 0;
}
.search-status .orderBtn {
  border-radius: 16px;
  width: 178px;
}

.myOrder-table {
  margin-top: 20px;
}
.myOrder-table>>>td,.myOrder-table>>>th{
  font-size: 12px;
}
.myOrder-table >>>.ant-table-thead th{
  height: 40px;
  padding-top:0; 
  padding-bottom:0; 
}
.myOrder-table >>> thead th {
  background: #eef0f7;
  border-left: 1px solid #fff;
}
.operaGroup a {
  display: block;
}
.myOrder >>> .ant-drawer-title {
  text-align: center;
  color: #303445;
  font-size: 18px;
}
.myOrder >>> .ant-drawer-body {
  background: #f6f7fb;
  min-height: calc(100% - 55px);
}
.myOrder .section {
  background: #fff;
  padding: 20px;
  font-size: 12px;
}
.ant-table-tbody span,.ant-table-tbody td{
  word-break: break-all;
  word-wrap: break-word;
}
.order-info .ant-row:not(:last-child) {
  margin-bottom: 20px;
}
.order-step {
  margin-top: 20px;
}
.order-step .title{
  font-size: 14px;
}
.order-step >>> .ant-steps-item-content {
  width: calc(100% - 30px);
}
.order-step >>> .ant-steps-item-title {
  width: 100%;
  padding-right: 0;
}
.order-step >>> .ant-steps-item-description{
  padding-bottom: 30px;
}
.detail-header {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  width: 100%;
}
.status {
  border-radius: 16px;
}
.redReportBox {
  width: 375px;
  height: 667px;
  position: relative;
  font-variant: normal; /**画布字体加粗丢失解方案**/
}
.redReportBox img {
  width: 100%;
  height: 100%;
}
.redReport-info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 236px 54px 0 54px;
  font-size: 14px;
  color: #444;
}
.redReport-title {
  text-align: right;
}
.redReport-value {
  font-weight: bold;
}
.redReport-row {
  margin-top: 2px;
  margin-bottom: 2px;
}
.audit_note {
  color: #ff7100;
}
.step-info {
  color: #59607b;
  font-size: 12px;
  margin-bottom: 10px;
}
.update-time {
  font-size: 12px;
  color: #9fa5bb;
  margin-bottom: 15px;
}
.step-info img {
  display: inline-block;
  vertical-align: top;
  width: 110px;
  height: 110px;
  border:1px solid rgba(232,234,245,1)
}
.order-step .status {
  width: 80px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}
.order-step .status.blue {
  color: #3091f2;
  background: #eaf4fe;
}

.order-step .status.red {
  color: #f2303e;
  background: #feeaeb;
}

.order-step .status.orange {
  color: #ff7100;
  background: #fff1e5;
}

.order-step .status.gray {
  color: #999;
  background: #f6f6f6;
}
.order-info-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

